import { ChartData } from "chart.js";
import { CreditCardGetResponse, CreditCardHistoryGetResponse } from "ApiClient/models";

export const generateCreditCardChartData = (
    currency: string,
    data: {
        nonPromotional: number;
        promotional: number;
        available: number;
    }
): ChartData<"pie"> => {
    return {
        labels: ["Standard Rate", "Promotional Rate", "Available"],
        datasets: [
            {
                label: currency,
                data: [data.nonPromotional, data.promotional, data.available],
                backgroundColor: [
                    "rgba(255, 99, 132, 0.6)",
                    "rgba(255, 206, 86, 0.6)",
                    "rgba(75, 192, 192, 0.6)",
                ],
            }
        ]
    };
};

export const generateCreditCardChartDataMini = (currency: string, data: CreditCardGetResponse): ChartData<"pie"> => {
    const calculation = {
        promotional: data.promotionalBalance,
        available: data.creditLimit - data.balance,
        nonPromotional: data.balance - data.promotionalBalance
    };

    return generateCreditCardChartData(currency, calculation);
};

export const generateLoanChartData = (currency: string, data: {
    balance: number;
    originalLoanAmount: number;
    totalPayable: number;
}): ChartData<"pie"> => {
    return {
        labels: ["Paid", "Remaining", "Interest", "Loan Amount"],
        datasets: [
            {
                label: currency,
                data: [data.totalPayable - data.balance, data.balance, 0, 0],
                backgroundColor: [
                    "rgba(75, 192, 192, 0.6)",
                    "rgba(255, 99, 132, 0.6)",
                    "rgba(255, 206, 86, 0.6)",
                    "rgba(75, 132, 255, 0.6)",
                ],
            },
            {
                label: currency,
                data: [0, 0, data.totalPayable - data.originalLoanAmount, data.originalLoanAmount],
                backgroundColor: [
                    "rgba(75, 192, 192, 0.6)",
                    "rgba(255, 99, 132, 0.6)",
                    "rgba(255, 206, 86, 0.6)",
                    "rgba(75, 132, 255, 0.6)",
                ],
            },
        ]
    };
};

export const generateMortgageChartData = (currency: string, data: {
    balance: number;
    equity?: number | null;
}) => {
    if (!data.equity) return null;

    return {
        labels: ["Equity", "Balance"],
        datasets: [
            {
                label: currency,
                data: [data.equity, data.balance],
                backgroundColor: [
                    "rgba(75, 192, 192, 0.6)",
                    "rgba(255, 206, 86, 0.6)",
                ],
            },
        ]
    };
};

export const generateCreditCardHistoryChartData = (
    data: CreditCardHistoryGetResponse[]
): ChartData<"line"> => {
    return {
        labels: data.map(entry => new Date(entry.date).toLocaleDateString()),
        datasets: [
            {
                label: "Balance",
                data: data.map(entry => entry.balance - entry.promotionalBalance),
                borderColor: "rgb(255, 140, 165)",
                backgroundColor: "rgb(255, 140, 165)",
                fill: true
            },
            {
                label: "Promotional Balance",
                data: data.map(entry => entry.promotionalBalance),
                borderColor: "rgb(255, 220, 133)",
                backgroundColor: "rgb(255, 220, 133)",
                fill: true
            },
            {
                label: "Available Credit",
                data: data.map(entry => entry.creditLimit - entry.balance),
                borderColor: "rgb(122, 226, 226)",
                backgroundColor: "rgb(122, 226, 226)",
                fill: true
            }
        ]
    };
};